<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-10-13 15:44:09
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\CustomForm\CustomForm\components\editItem.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-02 18:02:42
-->
<template>
  <normalDialog
    :title="$t('label_essweb_customForm_form_dialog_editItem')"
    :dialog="show"
    @close="closeDialog"
    width="600"
    scrollable
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="py-0 my-0">
            <v-switch
              color="primary"
              class="ml-4"
              v-model="customFormItemData.is_required"
              :label="
                customFormItemData.is_required
                  ? $t('label_essweb_customForm_form_dialog_isMandatoryLabel')
                  : $t(
                      'label_essweb_customForm_form_dialog_isNotMandatoryLabel'
                    )
              "
            ></v-switch>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="customFormItemData.custom_field_name"
              maxlength="100"
              :TrigerInit="show"
              @change="
                (valueArr) => {
                  customFormItemData.custom_field_name = valueArr;
                }
              "
              :label="$t('label_essweb_customForm_form_dialog_labelLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_customForm_form_dialog_typeLabel")
            }}</v-sheet>
            <v-autocomplete
              :items="Types"
              item-text="view_fields"
              item-value="value_field"
              single-line
              :rules="$GetRules(['_Require_Rules'], [null])"
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              v-model="customFormItemData.custom_field_data_type"
              filled
              :label="$t('label_essweb_customForm_form_dialog_typeLabel')"
              dense
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :bindData="customFormItemData.custom_field_placeholder"
              maxlength="100"
              :TrigerInit="show"
              @change="
                (valueArr) => {
                  customFormItemData.custom_field_placeholder = valueArr;
                }
              "
              :label="
                $t('label_essweb_customForm_form_dialog_placeHolderLabel')
              "
            />
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <numberInputTextFiled
              :rules="
                $GetRules(['_Number_negative', '_Length_Rules'], [null, 15])
              "
              v-model="customFormItemData.sequence"
              :label="$t('label_essweb_customForm_form_dialog_sequenceLabel')"
              isNotRequire
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <span class="text-h6 text--secondary">
              {{ $t("label_essweb_customForm_form_dialog_layoutLabel") }}</span
            >
            <v-tooltip top color="transparent">
              <template v-slot:activator="{ on, attrs }">
                <span
                  class="material-icons-round md-14 primary--text"
                  v-bind="attrs"
                  v-on="on"
                >
                  question_mark</span
                >
              </template>
              <v-sheet class="white elevation-3 pa-3 ma-n3 rounded-lg">
                <v-sheet class="d-flex text--secondary text-caption"
                  >{{
                    $t("label_essweb_customForm_form_dialog_colsLabel")
                  }}:12~24</v-sheet
                ><br />
                <v-sheet class="d-flex text--secondary text-caption">
                  <span class="material-icons-round md-18">smartphone</span
                  >{{
                    "< " + $vuetify.breakpoint.thresholds.xs + "px"
                  }} </v-sheet
                ><br />
                <v-sheet class="d-flex text--secondary text-caption">
                  <span class="material-icons-round md-18"
                    >stay_current_landscape</span
                  >{{
                    $vuetify.breakpoint.thresholds.xs +
                    "px > < " +
                    $vuetify.breakpoint.thresholds.sm +
                    "px"
                  }} </v-sheet
                ><br />
                <v-sheet class="d-flex text--secondary text-caption">
                  <span class="material-icons-round md-18">computer</span
                  >{{
                    $vuetify.breakpoint.thresholds.sm +
                    "px > < " +
                    $vuetify.breakpoint.thresholds.md +
                    "px"
                  }}</v-sheet
                ><br />
                <v-sheet class="d-flex text--secondary text-caption">
                  <span class="material-icons-round md-18">desktop_mac</span
                  >{{
                    $vuetify.breakpoint.thresholds.md +
                    "px > < " +
                    $vuetify.breakpoint.thresholds.lg +
                    "px"
                  }}</v-sheet
                ><br />
                <v-sheet class="d-flex text--secondary text-caption">
                  <span class="material-icons-round md-18">desktop_windows</span
                  >{{ "> " + $vuetify.breakpoint.thresholds.lg + "px" }}
                </v-sheet>
              </v-sheet>
            </v-tooltip>
          </v-col>
          <v-col xs="12" sm="12" md="6" lg="6" cols="12" class="py-0 my-0">
            <numberInputTextFiled
              readonly
              :rules="$GetRules(['_Number_negative'], [null])"
              v-model="customFormItemData.custom_field_data_layout.cols"
              :label="$t('label_essweb_customForm_form_dialog_colsLabel')"
              isNotRequire
              :max="24"
              :min="12"
            />
          </v-col>
          <v-col xs="12" sm="12" md="6" lg="6" cols="12" class="py-0 my-0">
            <span class="material-icons-round md-18">smartphone</span>
            <numberInputTextFiled
              readonly
              :rules="
                $GetRules(
                  ['_Number_negative', '_Number_Max'],
                  [
                    null,
                    {
                      number: customFormItemData.custom_field_data_layout.cols,
                    },
                  ]
                )
              "
              v-model="customFormItemData.custom_field_data_layout.xs"
              isNotRequire
              :max="customFormItemData.custom_field_data_layout.cols"
              :min="0"
            />
          </v-col>
          <v-col xs="12" sm="12" md="6" lg="6" cols="12" class="py-0 my-0">
            <span class="material-icons-round md-18"
              >stay_current_landscape</span
            >
            <numberInputTextFiled
              readonly
              :rules="
                $GetRules(
                  ['_Number_negative', '_Number_Max'],
                  [
                    null,
                    {
                      number: customFormItemData.custom_field_data_layout.cols,
                    },
                  ]
                )
              "
              v-model="customFormItemData.custom_field_data_layout.sm"
              :max="customFormItemData.custom_field_data_layout.cols"
              :min="0"
              isNotRequire
            />
          </v-col>
          <v-col xs="12" sm="12" md="6" lg="6" cols="12" class="py-0 my-0">
            <span class="material-icons-round md-18">computer</span>
            <numberInputTextFiled
              readonly
              :rules="
                $GetRules(
                  ['_Number_negative', '_Number_Max'],
                  [
                    null,
                    {
                      number: customFormItemData.custom_field_data_layout.cols,
                    },
                  ]
                )
              "
              v-model="customFormItemData.custom_field_data_layout.md"
              isNotRequire
              :max="customFormItemData.custom_field_data_layout.cols"
              :min="0"
            />
          </v-col>
          <v-col xs="12" sm="12" md="6" lg="6" cols="12" class="py-0 my-0">
            <span class="material-icons-round md-18">desktop_mac</span>
            <numberInputTextFiled
              readonly
              :rules="
                $GetRules(
                  ['_Number_negative', '_Number_Max'],
                  [
                    null,
                    {
                      number: customFormItemData.custom_field_data_layout.cols,
                    },
                  ]
                )
              "
              v-model="customFormItemData.custom_field_data_layout.lg"
              isNotRequire
              :max="customFormItemData.custom_field_data_layout.cols"
              :min="0"
            />
          </v-col>
          <v-col xs="12" sm="12" md="6" lg="6" cols="12" class="py-0 my-0">
            <span class="material-icons-round md-18">desktop_windows</span>
            <numberInputTextFiled
              readonly
              :rules="
                $GetRules(
                  ['_Number_negative', '_Number_Max'],
                  [
                    null,
                    {
                      number: customFormItemData.custom_field_data_layout.cols,
                    },
                  ]
                )
              "
              v-model="customFormItemData.custom_field_data_layout.xl"
              isNotRequire
              :max="customFormItemData.custom_field_data_layout.cols"
              :min="0"
            />
          </v-col> </v-row
      ></v-form>
    </template>
    <template v-slot:actions>
      <CardActions saveBtn @save="toSave" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "newItem",
  computed: {
    ...mapGetters(["companyLang"]),
    Types() {
      return this.$getSelectTrans(this.TypesData, "view_fields");
    },
  },
  props: {
    show: { default: false, type: Boolean },
    PropertyData: { default: null, type: [Object, Array, String] },
    curUuid: { default: "", type: [String, Number] },
  },
  mounted() {
    this.getTypes();
  },
  data() {
    return {
      TypesData: [],
      isEdited: true,
      customFormItemData: {
        uuid: "",
        custom_field_name: "",
        custom_field_placeholder: "",
        custom_field_data_type: "",
        custom_field_data_layout: {
          xs: 12,
          sm: 12,
          md: 6,
          lg: 6,
          xl: 4,
          cols: 12,
        },
        custom_field_data_type_name: "",
        is_required: 0,
        sequence: 1,
      },
    };
  },
  watch: {
    show(val) {
      if (val) {
      } else {
        if (this.$refs["form"]) this.$refs["form"].reset();
        this.customFormItemData = {
          uuid: "",
          custom_field_name: "",
          custom_field_placeholder: "",
          custom_field_data_type: "",
          custom_field_data_layout: {
            xs: 12,
            sm: 12,
            md: 6,
            lg: 6,
            xl: 4,
            cols: 12,
          },
          custom_field_data_type_name: "",
          is_required: 0,
          sequence: 1,
        };
      }
    },
    curUuid(val) {
      if (val) {
        this.getDetail(val);
      }
    },
    PropertyData(val) {
      const that = this;
      if (val) {
        this.customFormItemData.custom_field_data_layout =
          val.custom_field_data_layout;
        this.customFormItemData.custom_field_data_type =
          val["custom_field_data_type"];
        this.customFormItemData.is_required = val["is_required"];
        this.customFormItemData.sequence = val["sequence"] ? 1 : 0;
        this.customFormItemData.uuid = val["uuid"];
        this.$Sleep(400).then(() => {
          // 加延迟解决国际化输入问题
          that.customFormItemData.custom_field_name =
            that.$transOnLineCommonLangKey(
              that.companyLang,
              val["custom_field_name"]
            );
          that.customFormItemData.custom_field_placeholder =
            that.$transOnLineCommonLangKey(
              that.companyLang,
              val["custom_field_placeholder"]
            );
        });
      }
    },
    "customFormItemData.custom_field_data_type": function (val) {
      if (val)
        this.customFormItemData.custom_field_data_type_name =
          this.TypesData.find((ele) => ele["value_field"] === val)[
            "view_fields"
          ];
      if (!val) this.customFormItemData.custom_field_data_type_name = "";
    },
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    toSave() {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onEdit", JSON.parse(JSON.stringify(this.customFormItemData)));
    },
    getDetail: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_common_application_type_custom_field",
        url: "/common-application-type-custom-field/get-details/",
        data: {
          uuid: uuid,
        },
      }).then((res) => {
        res.data["custom_field_name_save"] = res.data.custom_field_name;
        res.data.custom_field_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.custom_field_name
        );
        res.data["custom_field_placeholder_save"] =
          res.data.custom_field_placeholder;
        res.data.custom_field_placeholder = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.custom_field_placeholder
        );
        let layout = that.$iSJson(res.data["custom_field_data_layout"]);
        res.data["custom_field_data_layout"] = layout
          ? layout
          : { xs: 12, sm: 12, md: 6, lg: 6, xl: 4, cols: 12 };
        this.customFormItemData = res.data;
      });
    },
    getTypes() {
      const that = this;
      this.$findPrompt({
        prompt_name: "custom_field_data_type_select",
      }).then((res) => {
        that.TypesData = res.data;
      });
    },
  },
};
</script>